import React from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';

import { ff } from '@atlassian/jira-feature-flagging';
import type { Field, SelectFieldOptionsType } from '../../types';
import { SelectFieldView } from '../common';
import { SingleSelectFieldReadView } from './read-view';

export const SingleSelectField = ({
	id,
	label,
	value,
	onChange,
	options,
	formattedOptions,
	isInline,
	getValueContainer,
}: Field) => {
	const mappedOptions: SelectFieldOptionsType[] =
		options?.map((option) => ({
			label: option,
			value: option,
		})) || [];
	const selectedOption: SelectFieldOptionsType | undefined = ff(
		'shipit-58-colours-for-detail-fields-in-csm_i6j6e',
	)
		? formattedOptions?.find((option) => option.value === value)
		: mappedOptions.find((option) => option.value === value);

	const onSelection = (
		selection: SelectFieldOptionsType | null | undefined,
		analyticsEvent: UIAnalyticsEvent,
	) => {
		if (selection?.value === value) return;

		onChange({ value: selection?.value || '' }, analyticsEvent);
	};

	return (
		<SelectFieldView
			id={id}
			isMulti={false}
			label={label}
			value={selectedOption}
			valueAsString={value}
			options={
				ff('shipit-58-colours-for-detail-fields-in-csm_i6j6e') ? formattedOptions : mappedOptions
			}
			onSelection={onSelection}
			readView={() => (
				<SingleSelectFieldReadView
					value={value}
					getValueContainer={getValueContainer}
					inInlineEdit
				/>
			)}
			isInline={isInline}
		/>
	);
};

export { SingleSelectFieldReadView };
